// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * ADR-085 IAP-4: the BUILD-TIME billing mode of the web bundle. It decides UNAUTHENTICATED copy only — the landing pricing section and
 * the legal pages (privacy policy, terms), which have no signed-in user and so no server answer to follow. The authenticated Access page
 * never reads this: it follows the SERVER (`offers.appStoreOnly`, see `accessView.ts`).
 *
 *  - `whop` (default, also any unknown value): the copy served today.
 *  - `app_store`: the Apple-billed copy — an ENGINEERING DRAFT that an attorney still has to confirm
 *    (docs/legal-draft-apple-billing-2026-10-04.md). It ships only when the founder deploys with `VITE_BILLING_MODE=app_store`
 *    (scripts/deploy-frontend.py), IMMEDIATELY AFTER the backend deploy with `whop_checkout_retired: true` and never before it: with the copy
 *    first, the terms would say "sold through the App Store" while the Access page can still open a real Whop checkout. Order: (a) the web
 *    in `whop` mode, (b) the backend flag, (c) this mode, (d) a new EAS build; (c) is a separate founder decision (docs/operations/apple-iap-setup.md section 7).
 *
 * Two switches, one owner each (server flag: what the API sells; this mode: what the static pages say). Retire this constant with the
 * Whop retirement (docs/RELEASE_GATES.md debt row).
 */
export type BillingMode = "whop" | "app_store"

export const BILLING_MODE: BillingMode = import.meta.env.VITE_BILLING_MODE === "app_store" ? "app_store" : "whop"
